export const append = (buttonElement) => {
  buttonElement
    .append("rect")
    // use this to select both the "rect" and the "ellipse" part of a button
    .classed("dashboard-button", true)
    // use this to select the "rect" part of the button, including its shadow
    .classed("dashboard-button-rect", true)
    // use this to select the "rect" and "ellipse" shadows
    .classed("dashboard-button-shadow", true)
    .attr("offset", 0)
    .style("display", "none")
    .style("stroke-width", 0)
    .style("fill", "black")
    .attr("rx", 8)
    .attr("ry", 8)
    .lower()
  buttonElement
    .append("ellipse")
    // use this to select both the "rect" and the "ellipse" part of a button
    .classed("dashboard-button", true)
    // use this to select the "ellipse" part of the button, including its shadow
    .classed("dashboard-button-ellipse", true)
    // use this to select the "rect" and "ellipse" shadows
    .classed("dashboard-button-shadow", true)
    .attr("offset", 0)
    .style("display", "inline")
    .style("stroke-width", 0)
    .style("fill", "black")
    .lower()
}

export const computeAttributes = (buttonElement) => {
  const shadowElement = buttonElement.selectAll(".dashboard-button-shadow")
  shadowElement.style(
    "transform",
    `translate(${Number(shadowElement.attr("offset"))}px, ${Number(
      shadowElement.attr("offset"),
    )}px)`,
  )
}
